exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".UserNavItem-default-1W6F1{overflow:hidden;margin:15px 10px;padding:5px;border-bottom:1px solid #d6dde1}.UserNavItem-container-1_Xl_{overflow:hidden;margin-right:48px;padding-right:20px}.UserNavItem-container-1_Xl_ .UserNavItem-name-2U3he{color:#00e5ce}.UserNavItem-container-1_Xl_ .UserNavItem-job-3zhlm{color:#b0bec5}.UserNavItem-container-1_Xl_ p{max-width:150px;margin:0;font-size:16px;font-weight:400}.UserNavItem-side-KH1Ht{float:right}.UserNavItem-side-KH1Ht .UserNavItem-user-2Diz6{display:block}", ""]);

// exports
exports.locals = {
	"default": "UserNavItem-default-1W6F1",
	"container": "UserNavItem-container-1_Xl_",
	"name": "UserNavItem-name-2U3he",
	"job": "UserNavItem-job-3zhlm",
	"side": "UserNavItem-side-KH1Ht",
	"user": "UserNavItem-user-2Diz6"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/user/components/UserNavItem.less
// module id = 1784
// module chunks = 0